module bm.optionalheader {
    'use strict';

    angular.module('bm.optionalheader', [])
        .directive('bmOptionalHeader', ['$location', ($location: ng.ILocationService): ng.IDirective => {
            return {
                link: ($scope: ng.IScope) => {
                    // Hide the header for workspace mode (paths will include /ws/)
                    $scope['bmOptionalHeaderVisible'] = $location.path().indexOf('/ws/') === -1;
                }
            };
        }]);
}
